import { render } from "./app-button-border-bottom.vue?vue&type=template&id=3798ce1b"
import script from "./app-button-border-bottom.vue?vue&type=script&lang=js"
export * from "./app-button-border-bottom.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/button/app-button-border-bottom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3798ce1b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3798ce1b', __exports__)) {
    console.log('reload')
    api.reload('3798ce1b', __exports__)
  }
  
  module.hot.accept("./app-button-border-bottom.vue?vue&type=template&id=3798ce1b", () => {
    console.log('re-render')
    api.rerender('3798ce1b', render)
  })

}


export default __exports__